import { Dispatch, SetStateAction } from 'react'
import { HoursReportForm, HoursReportFormData } from '@/components/forms'
import { useMutationWrapper, usePatchHoursReport } from '@/hooks'
import { HoursReport as HoursReportType } from '@/types'

export type HoursReportFormContainerProps = {
  data: HoursReportType
  setUpdatedHoursReport: Dispatch<SetStateAction<HoursReportType>>
  onSuccessUpdate: () => void
}

export const HoursReportFormContainer = ({
  data,
  setUpdatedHoursReport,
  onSuccessUpdate,
}: HoursReportFormContainerProps): JSX.Element => {
  const {
    mutateAsync: updateHoursReport,
    isLoading: mutateVisitLogInProcess,
    error,
  } = useMutationWrapper(() =>
    usePatchHoursReport({
      id: data.id,
    })
  )

  const handleHoursReportSubmit = async (formData: HoursReportFormData) => {
    if (data.research_visit_event) {
      const hoursReportData = {
        research_time_minutes: formData.research_time_minutes,
        research_time_comment: formData.research_time_comment,
        travel_time_minutes: formData.travel_time_minutes,
        travel_time_comment: formData.travel_time_comment,
        reporting_time_minutes: formData.reporting_time_minutes,
        reporting_time_comment: formData.reporting_time_comment,
        travel_distance_km: formData.travel_distance_km,
        travel_distance_comment: formData.travel_distance_comment,
        reported_as_coupled: formData.reported_as_coupled,
        car_pooling: formData.car_pooling,
        validation_message: formData.validation_message,
      }

      await updateHoursReport(hoursReportData, {
        successMessageKey: 'hoursReporting:notifications.hoursReportUpdated',
        onSuccess: (data) => {
          setUpdatedHoursReport(data)
          onSuccessUpdate()
        },
      })
    }
  }

  const defaultValues = {
    research_visit_event_id: data.research_visit_event?.id,
    research_time_minutes: data.research_time_minutes ?? 0,
    research_time_comment: data.research_time_comment ?? '',
    travel_time_minutes: data.travel_time_minutes ?? 0,
    travel_time_comment: data.travel_time_comment ?? '',
    reporting_time_minutes: data.reporting_time_minutes ?? 0,
    reporting_time_comment: data.reporting_time_comment ?? '',
    travel_distance_km: data.travel_distance_km ?? 0,
    travel_distance_comment: data.travel_distance_comment ?? '',
    reported_as_coupled: data.reported_as_coupled ?? false,
    car_pooling: data.car_pooling ?? false,
    validation_message: data.validation_message ?? '',
  }

  return (
    <HoursReportForm
      defaultValues={defaultValues}
      onSubmit={handleHoursReportSubmit}
      isLoading={mutateVisitLogInProcess}
      apiErrorData={error?.data}
    />
  )
}
